import styled from 'react-emotion';

export const ScrollListWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
